export function isInStock(stockStatus?: string | null) {
  return stockStatus === 'StockItem' || stockStatus === 'PendingSoldOut';
}
